import { render, staticRenderFns } from "./TikTokPlatformIcon.vue?vue&type=template&id=e6baa4a4&scoped=true"
import script from "./TikTokPlatformIcon.vue?vue&type=script&lang=js"
export * from "./TikTokPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6baa4a4",
  null
  
)

export default component.exports